module.exports = __webpack_public_path__ + "img/31.49d09d24.jpg";